export default "__VITE_ASSET__HAxBKbeI__"